"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const oxygen_config_1 = require("@8x8/oxygen-config");
const themeName_1 = __importDefault(require("../constants/themeName"));
const Icon_1 = __importDefault(require("./Icon"));
const Value_1 = __importDefault(require("./Value"));
const Action_1 = __importDefault(require("./Action"));
const LabelWrapper_1 = __importDefault(require("../styled/LabelWrapper"));
const LabelIconWrapper_1 = __importDefault(require("../styled/LabelIconWrapper"));
const Label = props => {
    const propsWithDefault = {
        testId: 'LABEL',
        value: '',
        action: '',
        actionLabel: '',
        infoBoxShowOn: 'hover',
        isDisabled: false,
        isRequired: false,
        shouldWrapText: false,
        showTooltipOnOverflow: true,
        ...props,
    };
    const { theme, testId, children, value, action, actionLabel, actionTarget, htmlFor, infoBoxText, infoBoxShowOn, infoBoxButtonLabel, isRequired, isDisabled, shouldWrapText, showTooltipOnOverflow, otherActionProps, ...rest } = propsWithDefault;
    const showAction = action && actionLabel;
    return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme },
        react_1.default.createElement(LabelWrapper_1.default, { ...rest },
            react_1.default.createElement(LabelIconWrapper_1.default, null,
                value && (react_1.default.createElement(Value_1.default, { testId: testId, value: value, htmlFor: htmlFor, isRequired: isRequired, isDisabled: isDisabled, shouldWrapText: shouldWrapText, showTooltipOnOverflow: showTooltipOnOverflow })),
                infoBoxText && (react_1.default.createElement(Icon_1.default, { infoBoxText: infoBoxText, infoBoxShowOn: infoBoxShowOn, infoBoxButtonLabel: infoBoxButtonLabel, theme: theme, testId: testId }))),
            showAction && (react_1.default.createElement(Action_1.default, { action: action, actionTarget: actionTarget, testId: testId, shouldWrapText: shouldWrapText, ...otherActionProps }, actionLabel)),
            children)));
};
exports.default = (0, oxygen_config_1.withTheme)((0, oxygen_config_1.withDeprecation)(Label, `Label deprecated props: "infoBoxContainer"`), themeName_1.default);
